import React from 'react'
import './PopAlerFromDown.css'
import { IoClose } from 'react-icons/io5';
import { useRef } from 'react'

const PopupwindowUseReducer = ({text, dispatch}) => {
    const slowHide = useRef();

  
    const handleClose = () => {
        slowHide.current.style.bottom = "-100%"
        setTimeout( ()=> {
            slowHide.current.style.bottom = "0"
            dispatch({type: "SET_POP_UP_WINDOW_DISABLE"})
        }, 300)
    }
  return (
    <div className='PopAlerFromDown' onClick={handleClose} ref={slowHide}>
        <div className='top'>
            <IoClose size={32}/>
        </div>
        <h2>{text}</h2>
    </div>
  )
}

export default PopupwindowUseReducer
